/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/step-backward-icon/step-backward-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=step-backward-icon.component.css.map */
